
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import {
  PANTRY_FOOD_TYPE,
  PANTRY_STORAGE_TYPE,
  PantryDetailInfo,
  StockQuantityInfo,
  PlateStockQuantityInfo,
  PANTRY_STRING
} from "@/types/pantry";
import PantryUtil from "@/utils/pantry-util";
import PantryDetailTitleView from "./PantryDetailTitleView.vue";
import PantryDetailDataView from "./PantryDetailDataView.vue";
import DateUtil from "@/utils/date-util";
export default defineComponent({
  name: "PantryDetailView",
  components: {
    PantryDetailTitleView,
    PantryDetailDataView
  },
  props: {
    type: {
      type: String,
      defalut: ""
    },
    info: {
      type: PantryDetailInfo,
      default: null
    },
    isShowData: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    //電池残量少の表示判定値(mV)
    const LOW_BATTERY_CHECK = 5100;
    const getUserInfo = () => {
      return props.info != null && props.info.user != null
        ? props.info.user
        : null;
    };
    const getPlateInfo = () => {
      return props.info != null && (props.info.plate != null) != null
        ? props.info.plate
        : null;
    };
    const getFridgeInfo = () => {
      return props.info != null && props.info.fridge != null
        ? props.info.fridge
        : null;
    };
    const getUpdateUser = () => {
      return props.info != null && props.info.updateUser != null
        ? props.info.updateUser
        : null;
    };
    const getUpdatePlate = () => {
      return props.info != null && props.info.updatePlate != null
        ? props.info.updatePlate
        : null;
    };
    const getUpdateFridge = () => {
      return props.info != null && props.info.updateFridge != null
        ? props.info.updateFridge
        : null;
    };
    const getName = () => {
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const user = getUserInfo();
        return user?.name;
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const plate = getPlateInfo();
        return plate?.name;
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const fridge = getFridgeInfo();
        return fridge?.name;
      }
      return "";
    };
    const getImage = () => {
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const user = getUserInfo();
        return user?.imageUrl;
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const plate = getPlateInfo();
        return plate?.imageUrl;
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const fridge = getFridgeInfo();
        return fridge?.imageUrl;
      }
      return "";
    };
    const getStock = () => {
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const user = getUserInfo();
        return user?.storageType;
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        return "重量検知";
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const fridge = getFridgeInfo();
        let roomName = PantryUtil.getRoomName(fridge?.roomId);
        if (roomName != "") {
          roomName += "/";
        }
        roomName += "カメラ検知";
        return roomName;
      }
      return "";
    };
    const getPlateName = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const plate = getPlateInfo();
        if (plate != null && plate.plate != null) {
          result = plate.plate.name;
        }
      }
      return result;
    };
    const getUpdateDate = () => {
      let result = "";
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        result = "";
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const plate = getPlateInfo();
        if (plate != null && plate.plate != null && plate.plate.item != null) {
          result = plate.plate.item.update;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const fridge = getFridgeInfo();
        if (fridge != null) {
          result = fridge.updateDate;
        }
      }
      if (result != "") {
        result = DateUtil.formatYYYYMMDD_hhmm(result);
      }
      return result;
    };
    const getStockQuantity = () => {
      const info = new StockQuantityInfo();
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const update = getUpdateUser();
        if (update != null) {
          info.value = PantryUtil.getStockQuantity(update.stockQuantity);
        }
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const plate = getPlateInfo();
        if (plate != null && plate.plate != null) {
          info.value = PantryUtil.getPlateValue(plate.plate);
          if (plate.plate != null) {
            info.plate = new PlateStockQuantityInfo(plate.plate);
          }
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const update = getUpdateFridge();
        if (update != null) {
          info.value = PantryUtil.getStockQuantity(update.stockQuantity);
        }
      }
      NativeClient.sendDebugLog(
        "PantryDetailView getStockQuantity info=" + JSON.stringify(info)
      );
      return info;
    };
    const getStorege = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const update = getUpdateUser();
        if (update != null) {
          result = update.storageType;
          if (result == null) {
            result = PANTRY_STORAGE_TYPE.ALL;
          }
        }
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const update = getUpdatePlate();
        if (update != null) {
          result = update.storageType;
          if (result == null) {
            result = PANTRY_STORAGE_TYPE.ALL;
          }
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const fridge = getFridgeInfo();
        if (fridge != null) {
          const id = fridge.roomId;
          result = PantryUtil.getRoomName(id);
        }
      }
      NativeClient.sendDebugLog("PantryDetailView getStorege result=" + result);
      return result;
    };
    const onShowDataSetting = () => {
      context.emit("show-data-setting");
    };
    const onChangeValue = (itemType: number) => {
      context.emit("change-value", itemType);
    };
    const getPurchaseDate = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const data = getUpdateUser();
        if (data != null) {
          result = data.purchaseDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const data = getUpdatePlate();
        if (data != null) {
          result = data.purchaseDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const data = getUpdateFridge();
        if (data != null) {
          result = data.purchaseDate;
        }
      }
      return result;
    };
    const getExpirationDate = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const data = getUpdateUser();
        if (data != null) {
          result = data.expirationDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const data = getUpdatePlate();
        if (data != null) {
          result = data.expirationDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const data = getUpdateFridge();
        if (data != null) {
          result = data.expirationDate;
        }
      }
      return result;
    };
    const getNotificationDate = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.USER) {
        const data = getUpdateUser();
        if (data != null) {
          result = data.notificationDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const data = getUpdatePlate();
        if (data != null) {
          result = data.notificationDate;
        }
      } else if (props.type == PANTRY_FOOD_TYPE.FRIDGE) {
        const data = getUpdateFridge();
        if (data != null) {
          result = data.notificationDate;
        }
      }
      return result;
    };
    const getNotificationStock = () => {
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const data = getUpdatePlate();
        if (data != null) {
          result = data.plate;
        }
      }
      return result;
    };
    const getPlateData = () => {
      NativeClient.sendDebugLog("getPlateData props.info=" + JSON.stringify(props.info));
      let result = null;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        result =
          props.info != null &&
          props.info.plateData != null &&
          props.info.plateData.data != null
            ? props.info.plateData
            : null;
      }
      return result;
    };
    const isShowLowBattery = () => {
      let result = false;
      if (props.type == PANTRY_FOOD_TYPE.PLATE) {
        const battery =
          props.info &&
          props.info.plateData &&
          props.info.plateData.data &&
          props.info.plateData.data.battery
            ? props.info.plateData.data.battery
            : LOW_BATTERY_CHECK;
        result = battery < LOW_BATTERY_CHECK;
      }
      return result;
    };
    const onUpdatePlate = () => {
      context.emit("click-update-plate");
    };
    const onShowGuide = () => {
      context.emit("show-guide");
    };
    return {
      getName,
      getImage,
      getStock,
      getPlateName,
      getUpdateDate,
      onShowDataSetting,
      onChangeValue,
      getStockQuantity,
      getStorege,
      getPurchaseDate,
      getExpirationDate,
      getNotificationDate,
      getNotificationStock,
      getPlateData,
      isShowLowBattery,
      onUpdatePlate,
      onShowGuide
    };
  }
});
